import { createSelector } from '@ngrx/store';

import { selectGalleryState } from '../reducers';

export const getSamplesState = createSelector(selectGalleryState, state => state.samples);

export const isSamplesLoaded = createSelector(getSamplesState, state => state.loaded);

export const isSamplesLoading = createSelector(getSamplesState, state => state.loading);
